import React, { useEffect, useRef } from 'react'

interface WallyReviewsProps {
  widgetId: string
}

export const WallyReviews: React.FC<WallyReviewsProps> = ({ widgetId }) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const loadWallyScript = () => {
      // Check if script is already loaded to prevent duplicates
      if (document.querySelector('script[src="https://embed.getwally.net/embed.js"]')) {
        return
      }

      const script = document.createElement('script')
      script.src = 'https://embed.getwally.net/embed.js'
      script.defer = true
      script.onerror = () => {
        console.error('Failed to load Wally embed script')
      }

      document.head.appendChild(script)
    }

    loadWallyScript()
  }, [])

  return (
    <div ref={containerRef} style={{ width: '100%', minHeight: '200px' }}>
      <div style={{ textAlign: 'right', marginBottom: '15px' }}>
        <a
          href="https://www.trustpilot.com/review/zehnlabs.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#007bff',
            textDecoration: 'none',
            fontSize: '14px'
          }}
        >
          See More reviews...
        </a>
      </div>
      <div
        id={`wally-reviews-${widgetId}`}
        data-wally-widget={widgetId}
        style={{ width: '100%', height: '100%' }}
      ></div>
    </div>
  )
}